import type { OrderRegionDetailResponse } from '../../openapi/types/OrderRegionDetail';

export type GroupedRegionsByType = {
  [key in OrderRegionDetailResponse['type']]: OrderRegionDetailResponse[];
};

export function groupRegionsByType(regions: OrderRegionDetailResponse[]): GroupedRegionsByType {
  return regions?.reduce((acc: GroupedRegionsByType, region): GroupedRegionsByType => {
    const key = region.type;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(region);
    return acc;
  }, {} as GroupedRegionsByType);
}
